import React, { useState } from 'react'
import { Tooltip } from '@overdose/components'
import classNames from 'classnames'

import Typography, { TypographyTag, TypographyVariant } from '../Typography'
import styles from './DropdownMenu.module.scss'
import { DropdownProps } from './DropdownMenu.types'

const defaultXOffset = -40
const defaultYOffset = 10

const DropdownMenu = ({
  children,
  options,
  onChange,
  offset = [defaultXOffset, defaultYOffset],
  wrapperClassname,
  position = 'bottom',
}: DropdownProps) => {
  const [popupVisible, setPopupVisible] = useState(false)

  return (
    <Tooltip
      theme={{
        root: classNames(styles.menu, wrapperClassname),
      }}
      trigger='click'
      popupVisible={popupVisible}
      triggerProps={{
        onOpen: () => {
          return setPopupVisible(true)
        },
      }}
      offset={offset}
      position={position}
      content={
        <div className={classNames('bg-white origin-top-right rounded-md')}>
          {options?.map((option, index) => {
            return (
              <button
                type='button'
                tabIndex={index}
                className={classNames(
                  'py-2 px-2.5 flex w-full',
                  styles.menuItem
                )}
                key={option.label}
                onClick={() => {
                  onChange(option.value)
                  setPopupVisible(false)
                }}>
                <Typography
                  variant={TypographyVariant.BodyRegular}
                  tag={TypographyTag.span}>
                  {option.label}
                </Typography>
              </button>
            )
          })}
        </div>
      }>
      <button type='button'>{children}</button>
    </Tooltip>
  )
}

export { DropdownMenu }
